import { LOAN_REQUEST_OFFER_SOURCES, LOAN_REQUEST_OFFER_STATES } from 'cpool-constants';
import {
    LoanRequest_EuropaceLoanOffersErrorsResponseReceived,
    LoanRequest_EuropaceLoanOffersSuccessResponseReceived,
} from 'cpool-events';
import { schemaConditions, schemaId } from 'cpool-schemas';
import { z } from 'zod';

export const schemaOfferRequestsCommon = z.object({
    applicant1Id: schemaId,
    applicant2Id: schemaId.optional(),
    conditions: schemaConditions,
    eventId: schemaId.nullable(),
    id: schemaId,
    loanRequestId: schemaId,
    requestedAt: z.number(),
    state: z.nativeEnum(LOAN_REQUEST_OFFER_STATES),
});

export const schemaOfferRequestsEuropace = z
    .object({
        failedReason: LoanRequest_EuropaceLoanOffersErrorsResponseReceived.prototype.getSchema().shape.reason,
        response: LoanRequest_EuropaceLoanOffersSuccessResponseReceived.prototype.getSchema().shape.response,
        source: z.literal(LOAN_REQUEST_OFFER_SOURCES.EUROPACE),
    })
    .merge(schemaOfferRequestsCommon);
